var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 62,
    viewBox: "0 0 85 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7439 60.1534L6.02729 48.2987C4.00998 47.5894 3.99953 44.7402 6.01158 44.0161L42.6574 30.8286C43.1655 30.6458 43.722 30.6498 44.2273 30.8399L79.2802 44.0276C81.2514 44.7692 81.2408 47.5613 79.264 48.2879L47.1262 60.1012C44.7463 60.976 42.136 60.9944 39.7439 60.1534Z",
    stroke: "#00FF94",
    strokeWidth: 0.737374
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6208 57.2862L10.4272 47.4222C9.16172 47.022 9.15569 45.2333 10.4185 44.8246L42.8733 34.3206C43.1521 34.2304 43.4526 34.2324 43.7302 34.3263L74.7741 44.8304C76.0141 45.2499 76.008 47.0059 74.7651 47.4168L44.9775 57.2643C43.8887 57.6243 42.7142 57.6319 41.6208 57.2862Z",
    fill: "#203376"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.499 18.9876L62.7262 16.0298V47.5005L52.499 50.4584V18.9876Z",
    fill: "#00FF94",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.499 18.9876L42.2718 16.0298V47.5005L52.499 50.4584V18.9876Z",
    fill: "white",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5639 13.0129L62.7274 16.0335L52.5035 18.9883L42.2718 16.0285L52.5639 13.0129Z",
    fill: "white",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0469 13.7376L42.2741 10.7798V47.4605L32.0469 50.4183V13.7376Z",
    fill: "#00FF94",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0469 13.7323L21.8197 10.7744V47.5739L32.0469 50.5317V13.7323Z",
    fill: "white",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1098 7.75513L42.2733 10.7757L32.0494 13.7305L21.8177 10.7706L32.1098 7.75513Z",
    fill: "white",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2734 28.3934L32.0462 25.4355L32.0462 29.6141L42.2734 32.572L42.2734 28.3934Z",
    fill: "white",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2735 28.3934L52.5007 25.4355L52.5006 29.6141L42.2734 32.572L42.2735 28.3934Z",
    fill: "#00FF94",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2734 32.575L32.0462 29.6172L32.0462 33.7957L42.2734 36.7536L42.2734 32.575Z",
    fill: "white",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2735 32.575L52.5007 29.6172L52.5006 33.7957L42.2734 36.7536L42.2735 32.575Z",
    fill: "#00FF94",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2734 36.7772L32.0462 33.8193L32.0462 37.9979L42.2734 40.9558L42.2734 36.7772Z",
    fill: "white",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2735 36.7772L52.5007 33.8193L52.5006 37.9979L42.2734 40.9558L42.2735 36.7772Z",
    fill: "#00FF94",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2734 40.9818L32.0462 38.0239L32.0462 42.2025L42.2734 45.1603L42.2734 40.9818Z",
    fill: "white",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2735 40.9818L52.5007 38.0239L52.5006 42.2025L42.2734 45.1603L42.2735 40.9818Z",
    fill: "#00FF94",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2734 45.1839L32.0462 42.2261L32.0462 46.4046L42.2734 49.3625L42.2734 45.1839Z",
    fill: "white",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2735 45.1839L52.5007 42.2261L52.5006 46.4046L42.2734 49.3625L42.2735 45.1839Z",
    fill: "#00FF94",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2734 49.3856L32.0462 46.4277L32.0462 50.6063L42.2734 53.5642L42.2734 49.3856Z",
    fill: "white",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2735 49.3856L52.5007 46.4277L52.5006 50.6063L42.2734 53.5642L42.2735 49.3856Z",
    fill: "#00FF94",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3344 22.4138L52.4979 25.4344L42.274 28.3891L32.0423 25.4293L42.3344 22.4138Z",
    fill: "white",
    stroke: "#101118",
    strokeWidth: 0.454545,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.52656d64ed756730a3c63621eba81c31.svg";
export { ForwardRef as ReactComponent };